module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/date-306.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/tools/date.md
// module id = 769
// module chunks = 450